export function initSlider() {
  const $ = (window as any).jQuery;

  // wamazing.com/snowのキャンペーンバナー用スライダー
  const snowTopBannerDesktop = $('.lead-frame-inner-pc .lead-frame-item');
  const snowTopBannerPhone = $('.lead-frame-inner-sp .lead-frame-item');
  const snowTopBannerDefaultOptions= {
      autoplay: true,
      infinite: true,
      autoplaySpeed: 8000,
      dots: true
  };
  const snowTopBannerDesktopOptions = {
    ...snowTopBannerDefaultOptions,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1190,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  if (snowTopBannerDesktop.length >= 1) {
    $('.lead-frame-inner-pc').slick(snowTopBannerDesktopOptions);
  }

  if (snowTopBannerPhone.length >= 1) {
    $('.lead-frame-inner-sp').slick(snowTopBannerDefaultOptions);
  }

  // wamazing.com/snow/resorts/code/accommodationsの宿レコメンド用スライダー
  const accommodationsNormalSlider = $('.normal_slider');
  const accommodationsRecommendSlider = $('.recommend_slider');

  accommodationsNormalSlider.on('init', () => {
    accommodationsNormalSlider.css('visibility', 'visible');
  });

  accommodationsRecommendSlider.on('init', () => {
    accommodationsRecommendSlider.css('visibility', 'visible');
    disableSlickDragWhenMobile();
  });

  accommodationsNormalSlider.slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: "unslick",
          slidesToScroll: 1,
          draggable: false,
        },
      },
    ],
  });

  accommodationsRecommendSlider.slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: "unslick",
          slidesToScroll: 1
        },
      },
    ],
  });

  if (accommodationsNormalSlider.length || accommodationsRecommendSlider.length) {
    $(window).on('resize orientationchange', () => {
      disableSlickDragWhenMobile();
    });
  }
};

function disableSlickDragWhenMobile() {
  const $ = (window as any).jQuery;
  const winWidth = (window as any).innerWidth;

  if (winWidth <= 480) {
    $('.slick-list').addClass('slick-list-disabled');
    $('.slick-list').removeClass('slick-list');
    // slickのtouchstartイベントリスナーの影響でスマホで横スクロールできないので、リスナー削除
    // How to remove all listeners in an element?: https://stackoverflow.com/a/28375061
    $('.slick-list-disabled').each((i: number, elem: Element) => {
      $(elem).replaceWith($(elem).clone());
    });
  } else {
    $('.slick-list-disabled').addClass('slick-list');
    $('.slick-list').removeClass('slick-list-disabled');
  }
}

document.addEventListener('turbolinks:load', () => {
  initSlider();
});
